// Step 19 — Risks page.
//
// Read-only surface over `deal_intelligence.sections.known_risks`.
// Now shares the same AIFindingCard component as the intelligence
// workspace so a "risk" looks the same everywhere and carries its
// evidence + "Fråga Qada" launcher.
//
// No fabricated scores — the severity labels come from the integer
// 1..5 values that WorkspaceRiskProfile already stores; anything else
// renders as "Okänd".

import { Link } from "react-router-dom";

import {
  AIEmpty,
  AILoading,
  AIPageHeader,
  AISection,
} from "../shell/AIPrimitives";
import { useAIWorkspace } from "../shell/AIWorkspaceContext";
import AIFindingCard from "../shell/intelligence/AIFindingCard";
import { extractRiskFindings } from "../shell/intelligence/helpers";

export default function AIRisks() {
  const { loading, dealIntel, activeWorkspace, activeWorkspaceId } = useAIWorkspace();
  if (loading) return <AILoading />;

  const findings = extractRiskFindings(dealIntel);

  return (
    <>
      <AIPageHeader
        title="Risker"
        subtitle={activeWorkspace?.organisation_name}
        actions={
          activeWorkspaceId ? (
            <Link
              to={`/deals/${activeWorkspaceId}/intelligence`}
              className="qai-page-section-link"
            >
              Öppna intelligence →
            </Link>
          ) : null
        }
      />
      {findings.length === 0 ? (
        <AIEmpty
          title="Inga registrerade risker"
          hint="Riskprofilen fylls i från broker-portalen; värden dyker upp här när de finns."
        />
      ) : (
        <AISection>
          <div className="qai-attention-queue">
            {findings.map((f) => (
              <AIFindingCard
                key={f.key}
                finding={f}
                workspaceId={activeWorkspaceId}
              />
            ))}
          </div>
        </AISection>
      )}
    </>
  );
}
